var parseInt10 = function (s) {
  return parseInt(s, 10);
};

export default parseInt10;